//const Backofficebff         : string = "/backofficebff/service/api/v1";
//const BackofficebffV2         : string = "/backofficebff/service/api/v2";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;
export const MobileAppHandlerCommand: any = {
    RemoveMobileAppHandler: Backofficebff + '/v1/mobilpanelapplication/config',
    UpdateMobileAppHandler: Backofficebff + '/v1/mobilpanelapplication/update',
    CreateMobileAppHandler: Backofficebff + '/v1/mobilpanelapplication/create',
    CreateMobileAppHandlerV2: Backofficebff + '/v2/mobilepanel/create-application',
};
